import Cookies from 'js-cookie'
import storage from 'storage-sdk'

const ddky_pop_sobot_token = 'ddky_pop_sobot_token' // 智齿token设置
const userInfo = 'u'
export const TokenKey = 'loginToken'

export function getToken() {
    return storage.get(TokenKey) // Cookies.get(TokenKey)
}

export function setToken(token) {
    Cookies.set(ddky_pop_sobot_token, token, { domain: 'ddky.com' })
    // storage.set(ddky_pop_sobot_token, token, { type: 'c', domain: 'ddky.com' })
    return storage.set(TokenKey, token, { type: 'l' }) // Cookies.set(TokenKey, token)
}

export function removeToken() {
    // Cookies.remove(ddky_pop_sobot_token)
    storage.remove(ddky_pop_sobot_token)
    return storage.remove(TokenKey) // Cookies.remove(TokenKey)
}

export function getUserInfo() {
    // Cookies.get(userInfo)
    return storage.get(userInfo)
}

export function setUserInfo(user) {
    return storage.set(userInfo, user) // Cookies.set(userInfo, user)
}

export function removeUserInfo() {
    return storage.remove(userInfo) // Cookies.remove(userInfo)
}
